var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParkinglot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 0H2.8C1.26 0 0 1.26 0 2.8V25.2C0 26.74 1.26 28 2.8 28H25.2C26.74 28 28 26.74 28 25.2V2.8C28 1.26 26.74 0 25.2 0ZM25.2 25.2H2.8V2.8H25.2V25.2Z",
    fill: "#2898FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 16.8C10.5732 16.8 11.2 16.1732 11.2 15.4C11.2 14.6268 10.5732 14 9.8 14C9.0268 14 8.4 14.6268 8.4 15.4C8.4 16.1732 9.0268 16.8 9.8 16.8Z",
    fill: "#2898FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 16.8C18.9732 16.8 19.6 16.1732 19.6 15.4C19.6 14.6268 18.9732 14 18.2 14C17.4268 14 16.8 14.6268 16.8 15.4C16.8 16.1732 17.4268 16.8 18.2 16.8Z",
    fill: "#2898FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.292 23.1H5.908C6.51 23.1 7 22.596 7 21.966V20.3H21V21.966C21 22.596 21.476 23.1 22.092 23.1H22.708C23.31 23.1 23.8 22.596 23.8 21.966V12.866C22.652 9.422 21.924 7.224 21.616 6.3C21.546 6.076 21.448 5.894 21.35 5.74C21.322 5.712 21.308 5.684 21.28 5.642C20.748 4.914 19.992 4.9 19.992 4.9H8.008C8.008 4.9 7.252 4.914 6.72 5.656C6.692 5.684 6.678 5.712 6.65 5.74C6.552 5.894 6.454 6.076 6.384 6.3C6.076 7.224 5.348 9.408 4.2 12.866V21.966C4.2 22.596 4.69 23.1 5.292 23.1ZM8.862 7.7H19.138L19.46 8.666L20.062 10.5H7.938L8.862 7.7ZM7 13.3H21V17.5H7V13.3Z",
    fill: "#2898FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkinglot);
export default __webpack_public_path__ + "static/media/parkinglot.5338d08ef7ae8f85f85124f60463a591.svg";
export { ForwardRef as ReactComponent };